// extracted by css-extract-rspack-plugin
export default {"navigator":"Navi__navigator--hN1FW","body":"Navi__body--B19dG","item":"Navi__item--Y3x4t"};